import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Visible SMS opt-in label shared by contact and landing forms (A2P 10DLC).
 */
function SmsConsentLabelText() {
  return (
    <span>
      Text me about my request at this number. Message frequency varies.
      Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
      Consent is not required to purchase or book. See our{' '}
      <Link to="/privacy#sms">Privacy Policy</Link>
      {' '}and <Link to="/terms#sms">Terms of Use</Link>.
    </span>
  );
}

export default SmsConsentLabelText;
